import React from 'react'
import { convertMinutesToHHMM, indFormatPrice } from 'utils/commonFun'

const DGParameters = ({ DGParametersData }) => {
    // console.log('DGParametersData', DGParametersData)
    return (
        <div className="_card">
            <div className="power_units parameters">
                <h4>DG Parameters</h4>
                <ul>
                    <li>
                        <span>Total runtime</span>
                        <b>{convertMinutesToHHMM(DGParametersData?.totalRuntime)}</b>
                    </li>
                    <li>
                        <span>Average runtime</span>
                        <b>{convertMinutesToHHMM(DGParametersData?.avgRuntime)}</b>
                    </li>
                    <li>
                        <span>Fuel Consumption</span>
                        <b>{DGParametersData?.fuelConsumption||'0'} L</b>
                    </li>
                    <li>
                        <span>Energy Cost</span>
                        <b>{indFormatPrice(DGParametersData?.energyCost)}</b>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default DGParameters